import React from 'react';

class _ResizeObserver {
    constructor() {
        this.observables = [];
        this.boundCheck = this.check;
        this.boundCheck();
    }

    observe(el, callback) {
        if (!el) return;
        const newObservable = {
            el: el,
            callback: callback.bind(el),
            size: {
                height: el.clientHeight,
                width: el.clientWidth
            }
        };
        this.observables.push(newObservable);
    }

    unobserve(el) {
        this.observables = this.observables.filter(
            obj => obj.el !== null && obj.el !== el
        );
    }

    check = () => {
        this.observables.map(obj => {
            if (!obj.el) return null;
            const currentHeight = obj.el.clientHeight;
            const currentWidth = obj.el.clientWidth;
            if (
                obj.size.height !== currentHeight ||
                obj.size.width !== currentWidth
            ) {
                obj.callback();
                obj.size.height = currentHeight;
                obj.size.width = currentWidth;
            }
            return obj;
        });
        if (!this.isPaused) {
            window.requestAnimationFrame(this.boundCheck);
        }
    };
}

class ResizableDiv extends React.Component {
    constructor(props) {
        super(props);
        if (props.innerRef) {
            this.innerRef = props.innerRef;
        }
    }

    getSize = () => {
        if (!this.el) return;
        const width = this.el.clientWidth;
        const height = this.el.clientHeight;
        return { width, height };
    };

    componentDidMount() {
        const { props } = this;

        const size = this.getSize();
        if (size === null) return;

        const { width, height } = size;

        if (props.onReady) props.onReady(this.el, width, height);

        if (props.onResize) {
            this.ro = new _ResizeObserver();
            this.ro.observe(this.el, () => {
                const size = this.getSize();
                if (size === null) return;
                const { width, height } = size;
                props.onResize(this.el, width, height);
            });
        }
    }

    componentWillUnmount() {
        if (!this.el) return;
        if (this.ro) this.ro.unobserve(this.el);
    }

    render() {
        const props = { ...this.props };
        delete props.onReady;
        delete props.onResize;
        delete props.innerRef;

        return (
            <div
                {...props}
                ref={el => {
                    if (this.innerRef) this.innerRef(el);
                    this.el = el;
                }}
                style={{ overflow: 'hidden', height: '100%', ...props.style }}
            >
                {props.children}
            </div>
        );
    }
}

export default ResizableDiv;
